import { useInfiniteQuery } from '@tanstack/react-query';
import { api } from '../api/client';
import { unwrap } from '../api/api-error';
import type { components } from '../api/schema';

export type DiagramItem = components['schemas']['DiagramItem'];
export type Diagram = components['schemas']['Diagram'];
export type DiagramNode = components['schemas']['DiagramNode'];
export type DiagramVersion = components['schemas']['DiagramVersion'];

export const diagramsKey = (workspaceId: string) =>
  ['workspaces', workspaceId, 'diagrams'] as const;
export const diagramKey = (workspaceId: string, diagramId: string) =>
  [...diagramsKey(workspaceId), diagramId] as const;

/** Схемы пространства постранично, свежеизменённые первыми, с превью (ADR-0018). */
export function useDiagrams(workspaceId: string) {
  return useInfiniteQuery({
    queryKey: [...diagramsKey(workspaceId), 'list'],
    initialPageParam: undefined as string | undefined,
    queryFn: async ({ pageParam }) =>
      unwrap(
        await api.GET('/api/v1/workspaces/{workspaceId}/diagrams', {
          params: {
            path: { workspaceId },
            query: pageParam === undefined ? {} : { cursor: pageParam },
          },
        }),
      ),
    getNextPageParam: (page) => page.nextCursor ?? undefined,
  });
}
